import { useRef, useEffect } from 'react';
import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import { getAWSToken } from 'services/awsToken';

const S3_BUCKET = 'oneclass-upload';
const REGION = 'ap-northeast-1';

export const useS3 = (roomId) => {
  const clientRef = useRef();

  useEffect(() => {
    if (!roomId) return;
    getAWSToken(roomId).then((res) => {
      const { accessKeyId, secretAccessKey, sessionToken } = res;

      clientRef.current = new S3Client({
        region: REGION,
        credentials: {
          accessKeyId,
          secretAccessKey,
          sessionToken,
        },
      });
    });
  }, [roomId]);

  const getFileExtension = (filename) => {
    return filename.split('.').pop();
  };

  const upload = async (file, type = 'file', filename) => {
    const path = `${roomId}/upload/${filename}`;
    const body = type === 'buffer' ? file?.buf : file;

    const uploader = new Upload({
      client: clientRef.current,
      params: {
        Bucket: S3_BUCKET,
        Key: path,
        Body: body,
        ContentType: type,
      },
    });

    uploader.on('httpUploadProgress', (evt) => {
      if (evt && evt.total) {
        console.log(Math.round((evt.loaded / evt.total) * 100));
      }
    });

    try {
      await uploader.done();
      return {
        state: 'success',
        url: `${process.env.REACT_APP_UPLOAD_CDN}/${roomId}/upload/${filename}`,
      };
    } catch (err) {
      return Promise.reject({
        state: 'error',
        err,
      });
    }
  };

  return {
    upload,
  };
};
